import { useEffect } from "react";
import { toast } from "sonner";

/* Auto-update: new build detected → banner (tap to refresh) + silent reload when the app goes to background. Never reloads mid-use. */
const manifestMain = async () => {
  const r = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) throw new Error("no manifest");
  const j = await r.json();
  return j?.files?.["main.js"] || j?.entrypoints?.join("|") || "";
};

export default function AutoUpdate() {
  useEffect(() => {
    let base = null, pending = false, reloading = false;
    const doReload = () => { if (reloading) return; reloading = true; window.__pwaReloadOnControl = true; window.location.reload(); };
    const markPending = () => {
      if (pending) return;
      pending = true;
      window.__rlUpdatePending = true;
      window.dispatchEvent(new Event("pwa-update-available"));
    };
    const check = async () => {
      try {
        const cur = await manifestMain();
        if (base === null) { base = cur; return; }
        if (cur && cur !== base && !/bundle\.js/.test(cur)) { navigator.serviceWorker?.getRegistration?.().then((reg) => reg?.update()); markPending(); }
      } catch {}
    };
    check();
    const t = setInterval(check, 180000);
    // Reload only when the user COMES BACK to the app (never while it sits in the background — a hidden reload is what left phones on a blank screen).
    const vis = () => { if (document.visibilityState === "visible") { if (pending) doReload(); else check(); } };
    document.addEventListener("visibilitychange", vis);
    const sw = navigator.serviceWorker;
    const onCtrl = () => { if (base !== null) markPending(); };
    sw?.addEventListener("controllerchange", onCtrl);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", vis); sw?.removeEventListener("controllerchange", onCtrl); };
  }, []);
  return null;
}
